import { get } from 'lodash';
import googleConfig from '../config/google';
import { GOOGLE_INIT_TIMEOUT } from '../Constants';

const gapi = window.gapi;

class GoogleSheets {
   static instance = null;
   static isSignedIn = false;
   isInitialized = false;

   constructor() {
      if (GoogleSheets.instance) {
         return GoogleSheets.instance;
      }
      GoogleSheets.instance = this;
   }

   async handleClientLoad() {
      return new Promise((resolve, reject) => {
         if (!this.isInitialized) {
            gapi.load('client:auth2', {
               callback: async () => {
                  await this.initClient();
                  this.initAuthListener();
                  resolve();
               },
               onError: error => reject(error),
               timeout: GOOGLE_INIT_TIMEOUT,
               ontimeout: () => reject('Timeout')
            });
         } else {
            this.initAuthListener();
            resolve();
         }
      });
   }

   async initClient() {
      return gapi.client.init(googleConfig).then(
         () => (this.isInitialized = true),
         error => {
            console.log('Google Sheets error', error);
            this.isInitialized = false;
         }
      );
   }

   initAuthListener() {
      gapi.auth2.getAuthInstance().isSignedIn.listen(this.updateSignInStatus);
      this.updateSignInStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
   }

   async signIn() {
      try {
         await gapi.auth2.getAuthInstance().signIn();
      } catch (error) {
         console.log('Error signing in:', error);
         throw new Error('Sign-in failed');
      }
   }

   updateSignInStatus(isSignedIn) {
      GoogleSheets.isSignedIn = isSignedIn;
   }

   async signOut() {
      if (GoogleSheets.isSignedIn) {
         return gapi.auth2.getAuthInstance().signOut();
      }
   }

   async exportSheets(title, assets, includeEstimates) {
      if (!this.isInitialized) {
         await this.handleClientLoad();
      }
      if (!GoogleSheets.isSignedIn) {
         await this.signIn();
      }

      const response = await this.createSpreadSheet(title);
      const spreadSheetId = get(response, 'result.spreadsheetId');
      const sheetId = get(response, 'result.sheets[0].properties.sheetId');
      await this.writeSheet(spreadSheetId, sheetId, assets, includeEstimates);

      return spreadSheetId;
   }

   async createSpreadSheet(title) {
      return gapi.client.sheets.spreadsheets.create({ properties: { title } });
   }

   async writeSheet(spreadsheetId, sheetId, assets, includeEstimates) {
      const body = { values: [['Title'], ['Sample Data']] };

      await gapi.client.sheets.spreadsheets.values.update({
         spreadsheetId,
         range: 'Sheet1',
         valueInputOption: 'USER_ENTERED',
         resource: body
      });

      return true;
   }
}

// Export a singleton instance
const googleSheetsSingleton = new GoogleSheets();
export default googleSheetsSingleton;
